import './PageHeader.css';

const PageHeader = ({ title, description, actions = null, className = '' }) => (
  <header className={`page-header ${className}`.trim()}>
    <div className="page-header-main">
      <h1 className="page-header-title">{title}</h1>
      {description ? <p className="page-header-description">{description}</p> : null}
    </div>
    {actions ? <div className="page-header-actions">{actions}</div> : null}
  </header>
);

export default PageHeader;
